module.exports = __webpack_public_path__ + "static/img/source_1.f6c9bd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/source_1.png
// module id = Yv+w
// module chunks = 60